module.exports = __webpack_public_path__ + "static/img/maozi.d41f195.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maozi.png
// module id = EORw
// module chunks = 3